import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicContextBarTemplateComponent } from './dynamic-context-bar-template.component';
import { ContextBarDirective } from './context-bar.directive';

@NgModule({
    imports: [CommonModule],
    exports: [ContextBarDirective, DynamicContextBarTemplateComponent],
    declarations: [ContextBarDirective, DynamicContextBarTemplateComponent],
    providers: [],
})
export class ContextBarDirectiveModule {}
